import styled from 'styled-components';

export const Headline1 = styled.h1`
    font-weight: 600;
    font-size: 28px;
`;
